const capitalizeFirstLetter = () => {
    function capitalizeFirstLetter(str) {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    function fixLearnDashButtons() {
        const buttons = document.querySelectorAll('.wpProQuiz_button, .learndash_next_quiz');

        buttons.forEach(button => {
            if(button.value) {
                button.value = capitalizeFirstLetter(button.value);
            } else if(button.textContent) {
                button.textContent = capitalizeFirstLetter(button.textContent);
            }
        });
    }

    const observer = new MutationObserver((mutationsList, observer) => {
        fixLearnDashButtons();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('DOMContentLoaded', fixLearnDashButtons);

};

export default capitalizeFirstLetter;
